import { useCallback, useLayoutEffect, useState } from 'react';

export const useComputedFont = () => {
  const [node, setNode] = useState<HTMLDivElement | null>(null);
  const [font, setFont] = useState<string | undefined>(undefined);

  // Этот ref вызовется при присвоении/снятии ref на элемент
  const ref = useCallback((el: HTMLDivElement | null) => {
    setNode(el);
  }, []);

  useLayoutEffect(() => {
    if (!node) return;

    const compute = () => {
      const fam = getComputedStyle(node).fontFamily;
      setFont(fam);
    };

    compute();
  }, [node]);

  return [ref, font] as const;
};
